import React from 'react';

const pct = (v) => (v == null ? '—' : `${v}%`);

export function KpiSummaryCards({ summary, loading }) {
  if (loading) return <p className="loading-msg">Loading summary…</p>;
  const s = summary || {};
  const cards = [
    { label: 'Approved submissions', value: s.approved_count == null ? '—' : String(s.approved_count) },
    { label: 'Approved-to-due', value: pct(s.approved_to_due) },
    { label: 'Completed %', value: pct(s.completed_pct) },
    { label: 'Avg score', value: pct(s.avg_score) },
  ];
  return (
    <div className="summary-cards">
      {cards.map((c) => (
        <div className="summary-card" key={c.label}>
          <div className="value">{c.value}</div>
          <div className="label">{c.label}</div>
        </div>
      ))}
    </div>
  );
}
